import React from 'react';

/**
 * Row of saldo cards for each payment type.
 */

const SALDO_ITEMS = [
  { key: 'gotowka', label: 'Gotówka', color: 'var(--success)', icon: 'fas fa-money-bill' },
  { key: 'karta', label: 'Karta', color: 'var(--info)', icon: 'fas fa-credit-card' },
  { key: 'blik', label: 'BLIK', color: 'var(--info)', icon: 'fas fa-mobile-alt' },
  { key: 'przelew', label: 'Przelew', color: 'var(--warning)', icon: 'fas fa-university' }
];

function SaldoCard({ value, label, color, icon, onClick, title, cursor }) {
  return (
    <div
      style={{
        flex: '1',
        minWidth: '140px',
        padding: '0.5rem 0.75rem',
        backgroundColor: 'var(--card-bg)',
        border: '1px solid var(--border)',
        borderLeft: `3px solid ${color}`,
        borderRadius: '4px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        cursor: cursor || 'default'
      }}
      onClick={onClick}
      title={title}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h3 style={{ margin: 0, fontSize: '0.85rem', fontWeight: '700', color }}>
            {value?.toFixed(2) || '0.00'} zł
          </h3>
          <p style={{ margin: 0, fontSize: '0.7rem', color: 'var(--text-muted)' }}>{label}</p>
        </div>
        <i className={icon} style={{ color, opacity: 0.4, fontSize: '1rem' }}></i>
      </div>
    </div>
  );
}

function SaldoCards({ saldo }) {
  if (!saldo) return null;

  return (
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem', flexWrap: 'wrap' }}>
      {SALDO_ITEMS.map((item) => (
        <SaldoCard
          key={item.key}
          value={saldo[item.key]}
          label={item.label}
          color={item.color}
          icon={item.icon}
        />
      ))}
    </div>
  );
}

export default SaldoCards;
